class EventTracker {
    constructor() {
        this.registry = [];
    }

    track(event) {
        this.registry.push(event);
    }

    forget(event) {
        this.registry.splice(this.registry.indexOf(event), 1);
    }

    isValid(event) {
        return this.registry.indexOf(event) !== -1;
    }
}

export default EventTracker;
